import { render } from "./GoogleCalendarNotice.vue?vue&type=template&id=6e2a289d&scoped=true"
import script from "./GoogleCalendarNotice.vue?vue&type=script&lang=js"
export * from "./GoogleCalendarNotice.vue?vue&type=script&lang=js"

import "./GoogleCalendarNotice.vue?vue&type=style&index=0&id=6e2a289d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2a289d"]])

export default __exports__